import IOSSwitch from './IosSwitch';
import type { NotificationKey, NotificationSetting } from './types';

type NotificationsSectionProps = {
  data: {
    settings: Record<NotificationKey, boolean>;
    emailEnabled: boolean;
    appEnabled: boolean;
    isBusy: boolean;
    emailOptions: NotificationSetting[];
    appOptions: NotificationSetting[];
  };
  actions: {
    onToggle: (key: NotificationKey) => void;
    onToggleEmail: () => void;
    onToggleApp: () => void;
  };
};

const NotificationsSection = ({
  data,
  actions,
}: NotificationsSectionProps) => {
  const { settings, emailEnabled, appEnabled, isBusy, emailOptions, appOptions } =
    data;
  const { onToggle, onToggleEmail, onToggleApp } = actions;

  return (
  <div className="flex flex-col gap-10">
    <div>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-slate-900">Email Notifications</p>
          <p className="mt-1 text-sm text-slate-500">
            Enabled notifications will be send to the registered Email ID
          </p>
        </div>
        <IOSSwitch
          checked={emailEnabled}
          onChange={onToggleEmail}
          disabled={isBusy}
          inputProps={{ 'aria-label': 'Toggle email notifications' }}
        />
      </div>
      <div className="mt-4 border-b border-slate-200" />
      <div className="mt-4 flex flex-col gap-5">
        {emailOptions.map((option) => (
          <div
            key={option.key}
            className="flex flex-wrap items-center justify-between gap-4"
          >
            <div className={`max-w-[680px] ${emailEnabled ? '' : 'opacity-60'}`}>
              <p className="text-sm font-semibold text-slate-900">
                {option.label}
              </p>
              <p className="mt-1 text-sm text-slate-500">{option.description}</p>
            </div>
            <IOSSwitch
              checked={settings[option.key]}
              onChange={() => onToggle(option.key)}
              disabled={!emailEnabled || isBusy}
              inputProps={{ 'aria-label': `Toggle ${option.label}` }}
            />
          </div>
        ))}
      </div>
    </div>
    <div>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-slate-900">
            In App/Browser Notifications
          </p>
          <p className="mt-1 text-sm text-slate-500">
            Browser notifications require permission from your browser and can be
            managed in your browser settings.
          </p>
        </div>
        <IOSSwitch
          checked={appEnabled}
          onChange={onToggleApp}
          disabled={isBusy}
          inputProps={{ 'aria-label': 'Toggle in-app notifications' }}
        />
      </div>
      <div className="mt-4 border-b border-slate-200" />
      <div className="mt-4 flex flex-col gap-5">
        {appOptions.map((option) => (
          <div
            key={option.key}
            className="flex flex-wrap items-center justify-between gap-4"
          >
            <div className={`max-w-[680px] ${appEnabled ? '' : 'opacity-60'}`}>
              <p className="text-sm font-semibold text-slate-900">
                {option.label}
              </p>
              <p className="mt-1 text-sm text-slate-500">{option.description}</p>
            </div>
            <IOSSwitch
              checked={settings[option.key]}
              onChange={() => onToggle(option.key)}
              disabled={!appEnabled || isBusy}
              inputProps={{ 'aria-label': `Toggle ${option.label}` }}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default NotificationsSection;
